













































































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeader.vue'
import NavigationFooter from '@/components/NavigationFooter.vue'
import PageMixin from '@/mixins/PageMixin.vue'
import signaturePad from '@fr/signature-pad'
import { mapGetters, mapActions } from 'vuex'
import { ILegalCase } from '@/store/interface/ILegalCase'
import TrackingMixin from '@/mixins/TrackingMixin.vue'

@Component({
	name: 'SignaturePage',
	components: {
		PageHeader,
		NavigationFooter
	},
	mixins: [TrackingMixin],
	computed: {
		...mapGetters({
			refundId: 'refundData/getRefundId',
			legalCaseData: 'refundData/getLegalCaseData',
			caseIsSigned: 'refundData/caseIsSigned',
			stillCanSign: 'refundData/canGoBackToSign'
		})
	},
	methods: {
		...mapActions({
			signDocument: 'refundData/signDocument',
			canSignDocument: 'refundData/canSignDocument'
		})
	}
})
export default class SignaturePage extends Vue {
	private refundId!: string
	private legalCaseData!: ILegalCase
	private caseIsSigned!: boolean
	private stillCanSign!: boolean
	private signDocument!: Function
	private canSignDocument!: Function
	private willSignLater: boolean = false

	beforeMount () {
		if (this.refundId === '') {
			this.$router.push('step0')
		}

		if (this.caseIsSigned) {
			this.$router.push('step9')
		} else {
			this.canSignDocument(false)
		}
	}

	mounted () {
		// Initialising signature-pad 3rd-party module
		const signaturePadElement = document.querySelector('.js-signature-pad')
		signaturePad.init(signaturePadElement, () => {}, this.useBtnCallback)
	}

	/**
	 * In case when customer tries to navigate to the the Checkout page by
	 * clicking back action button in browser window, after creating a case,
	 * we redirect customer back to Signature, because of that the signature-pad
	 * initializes on the div of the destroyed element, and when the new
	 * Signature page appears, signature-pad is not working. To prevent that we
	 * remove this div before we destroy an element, which makes the signature
	 * pad work properly anytime we are clicking back button from Signature page
	 */
	beforeDestroy () {
		const remove: Function = el => el.parentElement.removeChild(el)
		const signaturePad: HTMLElement | null = document.querySelector('div.full-width')
		remove(signaturePad)
	}

	private onSignLaterInput (): void {
		this.canSignDocument(this.willSignLater)
	}

	/**
	 * Callback func that should sends the encoded signature in a base64string
	 * format, that later get's into the document. Used along with signature-pad
	 * module, which is custom, and hosted at flightright nexus private npm.
	 * you can check the functionality of the module by follosing this link
	 * https://gitlab.infra.flightright.net/frontend-assets/js-modules/signature-pad
	 *
	 * @param signaturePad 						- signaturePad is the instance of the
 	 *														signature-pad module, that is passed	whenever
	 *														we click the use button. It is hanged on the
	 *														button along with `init` function, which is
	 *														called when component is mounted.
	 */
	private useBtnCallback (signaturePad: any): void {
		// Retreiving the canvas data from signature pad module in base64 format
		const base64EncodedSignature = signaturePad.toDataURL('image/svg+xml').split(',')[1]
		this.signDocument({ base64EncodedSignature })
			.then(() => {
				this.$router.push('step9')
			})
			.catch((e: any) => {
				console.error(e)
			})
	}
}
